export const MEMBER_GRADE_OPTIONS = [
    { value: 'GENERAL', label: 'General' },
    { value: 'VIP', label: 'VIP' },
];
const MEMBER_GRADE_LABELS = {
    GENERAL: 'General',
    VIP: 'VIP',
};
export function formatMemberGrade(grade) {
    if (!grade || !Object.prototype.hasOwnProperty.call(MEMBER_GRADE_LABELS, grade)) {
        return 'General';
    }
    return MEMBER_GRADE_LABELS[grade];
}
export function memberGradeBadgeClass(grade) {
    return grade === 'VIP'
        ? 'border-amber-400/60 text-amber-300 bg-amber-400/10'
        : 'border-slate-500/50 text-slate-300 bg-slate-500/10';
}
